import Vue from 'vue'
import configs from '@/config'

let resource = null
const basePath = `${configs.baseUrl}/api/admin/template-packs`

const actions = {
  list: { method: 'GET', url: basePath },
  preview: { method: 'GET', url: `${basePath}/preview` },
  publish: { method: 'POST', url: basePath },
  unpublish: { method: 'DELETE', url: `${basePath}/{folderId}` },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const list = async () => {
  const res = await resource.list({})
  return res.body.data.packs
}

const preview = async (folderId) => {
  const res = await resource.preview({ folderId })
  return res.body.data
}

const publish = async (params) => {
  const res = await resource.publish({}, params)
  return res.body.data.pack
}

const unpublish = async (folderId) => {
  const res = await resource.unpublish({ folderId })
  return res.body.data
}

export default {
  initResource,
  list,
  preview,
  publish,
  unpublish,
}
